document.addEventListener('DOMContentLoaded', function() {
    $('body').toggleClass('loaded');
});